<template>
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb name="Transactions" :breadcrumb="breadcrumb"/>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <!-- users list start -->
        <section class="app-user-list">
          <!-- users filter start -->
          <div class="card">
            <h5 class="card-header">Search Filter</h5>
            <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
              <div class="col-md-4 user_plan">
                <span>Start Date</span>
                <datepicker :upperLimit="upperLimitDate" v-model="fromDate" class="form-control"/>
              </div>
              <div class="col-md-4 user_role">
                <span>End Date</span>
                <datepicker :upperLimit="upperLimitDate" v-model="toDate" class="form-control"/>
              </div>
              <div class="col-md-4 user_plan">
                <label></label>
                <input class="form-control" type="text" v-model="search" placeholder="Search here..."/>
              </div>
            </div>
            <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
              <div class="col-md-4 user_role">
                <SelectOptions
                    label=""
                    selectAppend="account"
                    labelValue="currency.code"
                    v-model="selectedAccount"
                    :url="showSelectAccountOption"
                    :externalData="$store.getters.getAccountData"
                />
              </div>
              <div class="col-md-4 user_plan">
                <SelectOptions
                    label=""
                    selectAppend="type"
                    labelValue="name"
                    v-model="selectedType"
                    :url="showSelectTypesOption"
                />
              </div>
              <div class="col-md-4 user_plan">
                <div class="form-group">
                  <label></label>
                <input class="form-control" type="text" v-model="customerEmail"   @input="validateEmail" placeholder="Search By Customer Email..."/>
                <span role="alert" class="text-danger" v-if="validationMsg['email'] != ''">{{ validationMsg['email'] }}</span>
                </div>
              </div>
            </div>
            <div class="d-flex  align-items-center mx-50 row pt-0">
              <div class="col-md-4 user_plan">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <SearchSelect
                        v-model="selectedStore"
                        @selectedFullObj="selectedFullObj"
                        url="v1/get-stores"
                        :extract-options="(res) => res.data?.stores || []"
                        placeholder="Search Store..."
                    />
<!--                    <div class="input-group input-group input-group-merge">-->
<!--                      <select class="form-control" v-model="selectedStore">-->
<!--                        <option :value="null">Select Store</option>-->
<!--                        <option :key="index" :value="option" v-for="(option, index) in storeData">-->
<!--                          {{ option.name }}-->
<!--                        </option>-->
<!--                      </select>-->
<!--                    </div>-->
                  </div>
                </div>
              </div>
              <div class="col-md-4 user_plan">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <div class="input-group input-group input-group-merge">
                      <select class="form-control" v-model="selectedTerminal">
                        <option :value="null">Select Terminal</option>
                        <option :key="index" :value="option" v-for="(option, index) in terminalData">
                          {{ option.name }}
                        </option>
                      </select>
                      <div v-if="terminalLoader" class="input-group-append">
                                <span class="input-group-text cursor-pointer">
                                  <div class="spinner-border text-primary spinner-border-sm"></div>
                                </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 user_plan">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <div class="input-group input-group input-group-merge">
                      <select class="form-control" v-model="selectedChannel">
                        <option :value="null">Select Channel</option>
                        <option :key="index" :value="option" v-for="(option, index) in channelData">
                          {{ option.name }}
                        </option>
                      </select>
                      <div v-if="channelLoader" class="input-group-append">
                                <span class="input-group-text cursor-pointer">
                                  <div class="spinner-border text-primary spinner-border-sm"></div>
                                </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="d-flex justify-content-between align-items-center mx-50 row pt-0 pb-2">
              <div class="col-md-12 user_status d-flex justify-content-end">
                <button type="button" class="btn btn-primary" @click="onSubmitFilters">Search</button>
                <button type="button" class="ml-2 btn btn-dark" @click="onClearFilters">Clear</button>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Transaction List</h4>
            </div>
            <div class="card-body">
              <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item" @click="tabToShow = 1">
                  <a class="nav-link" :class="tabToShow == 1 ? 'active' : ''" id="home-tab" data-toggle="tab"
                     href="#home" aria-controls="home" role="tab" aria-selected="true">Transaction</a>
                </li>
                <li class="nav-item" @click="tabToShow = 2">
                  <a class="nav-link" :class="tabToShow == 2 ? 'active' : ''" id="profile-tab" data-toggle="tab"
                     href="#profile" aria-controls="profile" role="tab" aria-selected="false">Pending</a>
                </li>
                <li class="nav-item" @click="tabToShow = 3">
                  <a class="nav-link" :class="tabToShow == 3 ? 'active' : ''" id="failure-tab" data-toggle="tab"
                     href="#failure" aria-controls="profile" role="tab" aria-selected="false">Failure</a>
                </li>
              </ul>
              <div class="tab-content">
                <div class="tab-pane " :class="tabToShow == 1 ? 'active' : ''" id="home" aria-labelledby="home-tab"
                     role="tabpanel">
                  <CommonTable
                      ref="commonTableRef"
                      url="v1/get-transactions"
                      :tableHeaderValues="tableHeaderValues"
                      :actions="actions"
                      :filteredData="filteredData"
                      customClass="table-scroll-y minimum-h"
                      :actionDropdown="true"
                      :tableAccordian="transactionChargesTable"
                      :exportData="exportData"
                      :hidePdfExportButton="true"
                  />
                </div>
                <div class="tab-pane" :class="tabToShow == 2 ? 'active' : ''" id="profile" aria-labelledby="profile-tab"
                     role="tabpanel">
                  <CommonTable
                      v-if="tab2sendCall"
                      url="v1/get-transactions"
                      :tableHeaderValues="tableHeaderValues"
                      :actions="pendingActions"
                      :filteredData="filteredDataPending"
                      customClass="table-scroll-y minimum-h"
                      :actionDropdown="true"
                      :tableAccordian="transactionChargesTable"
                      :exportData="exportData"
                      :hidePdfExportButton="true"
                  />
                </div>
                <div class="tab-pane" :class="tabToShow == 3 ? 'active' : ''" id="failure" aria-labelledby="failure-tab"
                     role="tabpanel">
                  <CommonTable
                      v-if="tab3sendCall"
                      url="v1/get-transactions"
                      :tableHeaderValues="tableHeaderValues"
                      :actions="pendingActions"
                      :filteredData="filteredDataFailed"
                      customClass="table-scroll-y minimum-h"
                      :actionDropdown="true"
                      :tableAccordian="transactionChargesTable"
                      :exportData="exportData"
                      :hidePdfExportButton="true"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- users list ends -->

      </div>
    </div>
  </div>
  <TransactionDetailModal :show="showTransactionRequestModal" :data="transactionRequestSelectedData"
                          :index="transactionRequestSelectedIndex"
                          @hide="showTransactionRequestModal = false"
                          :detailType="detailType"

  >

  </TransactionDetailModal>
  <RefundModal :show="showRefundModal" :transactionId="transactionId" :refundInitialAmount="refundInitialAmount"
               @hide="showRefundModal = false"></RefundModal>
</template>

<script>

import {ref} from "vue";
import Datepicker from 'vue3-datepicker'
import SearchSelect from "@/components/common/SearchSelect.vue";


export default {
  components:{
    SearchSelect,
    Datepicker
  },
  props: ['propFilters'],
  mounted() {
    // this.showSelectAccountOption = 'v1/get-wallet-list'
    // setTimeout(() => {
    //   this.showSelectTypesOption = 'v1/transaction-types'
    //   setTimeout(() => {
    //     this.tab2sendCall = true;
    //   }, 2000)
    // }, 4000)

    var tabShow = 1
    if(typeof(this.$route.query.tab) != 'undefined'){
      tabShow = this.$route.query.tab
    }
    else{
      tabShow = 1
    }

    this.showSelectAccountOption = 'v1/get-wallet-list'
    this.showSelectTypesOption = 'v1/transaction-types'

    if(typeof(this.propFilters) != 'undefined'){
      let propFilters = JSON.parse(this.propFilters)

      let filterData = {}


      // if(propFilters.selectedStore){
      //   this.selectedStore = propFilters.selectedStore
      //   filterData.storeId = this.selectedStore
      // }
      //
      // if(propFilters.selectedTerminal){
      //   this.selectedTerminal = propFilters.selectedTerminal
      //   filterData.terminalId = this.selectedTerminal.id
      // }
      //
      // if(propFilters.selectedChannel){
      //   this.selectedChannel = propFilters.selectedChannel
      //   filterData.channelId = this.selectedChannel.id
      // }

      if(propFilters.selectedType){
        this.selectedType = propFilters.selectedType
        filterData.transactionTypeId = this.selectedType.id
      }


      if(propFilters.transactionId){
        this.search = propFilters.transactionId
        filterData.transactionId = this.search
      }

      if(propFilters.customerEmail){
        this.customerEmail = propFilters.customerEmail
        filterData.customerEmail = this.customerEmail
      }



      if(propFilters.selectedAccount){
        this.selectedAccount = propFilters.selectedAccount
        filterData.selectedAccount = this.selectedAccount
        filterData.userAccountId = this.selectedAccount.id
      }

      if(propFilters.tabToShow){
        tabShow = propFilters.tabToShow
      }


      if(tabShow == 1){
        filterData.tabToShow = 1
        filterData.status = 1
        this.filteredData = filterData

      }else if(tabShow == 2){
        filterData.tabToShow = 2
        filterData.status = 0
        this.filteredDataPending = filterData
        this.tab2sendCall = true
      }else if(tabShow == 3){
        filterData.tabToShow = 3
        filterData.status = 2
        this.filteredDataFailed = filterData
        this.tab3sendCall = true
      }


    }

    this.tabToShow = tabShow

  },
  data() {
    return {
      // toDate: ref(new Date()),
      remainingFund:null,
      rowId:null,
      toDate: null,
      fromDate: null,
      validationMsg:{
        email:''
      },
      // fromDate: ref(new Date()),
      exportData:{
        cta: (exportType) => {
          let requestData = {
            exportAs: exportType,
            reportType: 'transaction',
            // transaction_type_id:this.selectedType?this.selectedType.id:'',
            // search:this.search,
          }

          if(this.selectedStore){
            requestData.storeId = this.selectedStore
          }
          if(this.selectedTerminal){
            requestData.terminalId = this.selectedTerminal.id
          }
          if(this.selectedChannel){
            requestData.channelId = this.selectedChannel.id
          }

          if(this.toDate){
            requestData.toDate = this.formatDate(this.toDate)
          }
          if(this.fromDate){
            requestData.fromDate = this.formatDate(this.fromDate)
          }

          if(this.search != ''){
            requestData.transactionId = this.search
          }
          if(this.customerEmail != ''){
            requestData.customerEmail = this.customerEmail
          }
          if(this.selectedType){
            requestData.transactionTypeId = this.selectedType.id
          }

          if(this.selectedAccount){
            requestData.userAccountId = this.selectedAccount.id
          }


          if (this.tabToShow == 1) {
            requestData.status = 1

          } else if (this.tabToShow == 2) {
            requestData.status = 0
          } else {
            requestData.status = 2
          }



          this.downloadReport(requestData)
        }
      },
      showRefundModal: false,
      transactionId: '',
      breadcrumb: [
        {name: 'App'},
        {name: 'Transactions'},
      ],
      transactionRequestSelectedData: null,
      transactionRequestSelectedIndex: 0,
      showTransactionRequestModal: false,
      showSelectAccountOption: '',
      showSelectTypesOption: '',
      tabToShow: 1,
      tab2sendCall: false,
      tab3sendCall: false,
      pendingHeaderValues: [
        {
          title: 'Transaction Id',
          valueKey: 'uuid',
          html: true,
          alter: function (value) {
            var html = ''
            if (value)
              html = `<span class="text-primary">${value}</span>`


            return html


          }
        },
        {
          title: 'Reference',
          valueKey: 'refrence',
        },
        {
          title: 'Gateway Reference Id',
          valueKey: 'gateway_reference_id',
          html: true,
          alter: function (value, row) {
            var html = ''
            if (value)
              html = `<span class="text-info">${value}</span>`

            if (row.payment_method && row.payment_method.name) {
              html = `
                <div class="row">
                    <div class="col-12">
                       ${html}
                        <div class="badge badge-light-primary mt-1">${row.payment_method.name}</div>
                    </div>
                </div>
                `;
            }

            return html


          }
        },
        {
          title: 'Account Title',
          valueKey: 'card_holder_name',
          html: true,
          alter: function (value) {
            var html = ''
            html = ` <a href="javascript:void()" class="badge badge-glow badge-dark">${value}</a>`

            return html


          }
        },
        {
          title: 'Account Num',
          valueKey: 'card_number',
          html: true,
          alter: function (value) {
            var html = ''
            if (value)
              html = `<span class="text-black">${value}</span>`


            return html


          }
        },
        {
          title: 'Amount',
          valueKey: 'amount',
          html: true,
          alter:  (value, row) => {
            var html = ''
            if (value)
              html = `<div  class=" font-weight-bolder text-dark">${parseFloat(value / 100).toFixed(this.amountDecimalPlaces)}</div><div class="badge badge-light-success ml-sm-1">${row.currency.code}</div>`


            return html


          }
        },
        // {
        //   title: 'Method',
        //   valueKey: 'payment_method.name',
        //   html: true,
        //   alter: function (value) {
        //     var html = ''
        //     if (value)
        //       html = ` <a href="javascript:void()" class="badge badge-glow badge-info">${value}</a>`
        //
        //     return html
        //
        //
        //   }
        // },
        {
          title: 'Type',
          valueKey: 'transaction_type.name',
          html: true,
          alter: function (value) {
            var html = ''
            if (value)
              html = ` <a href="javascript:void()" class="badge badge-glow badge-primary">${value}</a>`

            return html


          }
        },
        {
          title: 'Transaction Date/Time',
          titleHtml: `<br> <span class="text-warning font-weight-bolder">
														(Showing In GMT)
													</span>`,
          valueKey: 'created_at',
       alter: (value) => {
              return new Date(value).toISOString().slice(0, 16).replace('T', ' ')
          }
        },
      ],
      pendingActions: [
        {
          title: 'Details',
          cta: (row, index, btnIndex) => {
            this.$store.commit('setTransactionDetail', row)
            var propFilters = this.filteredDataFailed
            if(this.tabToShow == 2){
              propFilters = this.filteredDataPending
            }

            this.$router.push({name: 'transactions-details-with-id',query: { tab: this.tabToShow },params: {id:row.uuid,propFilters: JSON.stringify(propFilters)}})
          },
          loading: false
        },
        {
          title: 'Attempts History',
          cta: (row, index, btnIndex) => {
            this.$router.push({name: 'transactions-attempt', params: {uuid: row.uuid}})
          },

        },
      ],
      tableHeaderValues: [
        {
          title: 'Transaction Id',
          valueKey: 'uuid',
          html: true,
          alter: function (value) {
            var html = ''
            if (value)
              html = `<span class="text-primary">${value}</span>`


            return html


          }
        },
        {
          title: 'Gateway Reference Id',
          valueKey: 'gateway_reference_id',
          html: true,
          alter: function (value, row) {
            var html = ''
            if (value)
              html = `<span class="text-info">${value}</span>`

            if (row.payment_method && row.payment_method.name) {
              html = `
                <div class="row">
                    <div class="col-12">
                       ${html}
                        <div class="badge badge-light-primary mt-1">${row.payment_method.name}</div>
                    </div>
                </div>
                `;
            }

            return html


          }
        },
        {
          title: 'Sender Account Title',
          valueKey: 'sender_account_title',
          html: true,
          alter: function (value) {
            var html = ''
            html = ` <a href="javascript:void()" class="badge badge-glow badge-light-dark">${value}</a>`

            return html


          }
        },
        {
          title: 'Sender Account Num',
          valueKey: 'sender_account_number',
        },
        // {
        //   title: 'Receiver Account Title',
        //   valueKey: 'receiver_account_title',
        //   html: true,
        //   alter: function (value) {
        //     var html = ''
        //     html = ` <a href="javascript:void()" class="badge badge-glow badge-warning">${value}</a>`
        //
        //     return html
        //
        //
        //   }
        // },
        // {
        //   title: 'Method',
        //   valueKey: 'payment_method.name',
        //   html: true,
        //   alter: function (value) {
        //     var html = ''
        //     if (value)
        //       html = ` <a href="javascript:void()" class="badge badge-glow badge-info">${value}</a>`
        //
        //     return html
        //
        //
        //   }
        // },
        {
          title: 'Type',
          valueKey: 'transaction_type.name',
          html: true,
          alter: function (value) {
            var html = ''
            if (value)
              html = ` <a href="javascript:void()" class="badge badge-glow badge-light-primary">${value}</a>`

            return html


          }
        },
        {
          title: 'Income/Outcome',
          valueKey: 'receiver_user_id',
          html: true,
          alter: (value, row) => {
            let user_id = this.$store.getters.getLoggedInUser?.id
            if(!user_id){
              return ''
            }
            let receiver_user_id = row.receiver_user_id
            let sender_user_id = row.sender_user_id
            var html = ''
            if (user_id == receiver_user_id) {
              html = `\t<div class="text-black">
                      \t\t\t\t\t\t\t\t\t\t\t\t<span class="mr-2 oi-icon bgl-success">
                      \t\t\t\t\t\t\t\t\t\t\t\t\t<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      \t\t\t\t\t\t\t\t\t\t\t\t\t\t<g clip-path="url(#clip2)">
                      \t\t\t\t\t\t\t\t\t\t\t\t\t\t<path d="M11.4238 16.2304C11.2206 15.8106 11.4001 15.3027 11.8199 15.0996C12.9878 14.5376 13.9764 13.6642 14.6805 12.5707C15.4016 11.4501 15.7842 10.1501 15.7842 8.80952C15.7842 4.96369 12.6561 1.83556 8.81022 1.83556C4.96439 1.83556 1.83626 4.96369 1.83626 8.80952C1.83626 10.1501 2.21881 11.4501 2.93652 12.5741C3.6373 13.6676 4.62923 14.541 5.7972 15.103C6.21699 15.3061 6.39642 15.8106 6.19329 16.2337C5.99017 16.6535 5.48574 16.833 5.06256 16.6298C3.61022 15.9324 2.38131 14.8491 1.51126 13.4882C0.617512 12.0934 0.143554 10.4751 0.143554 8.80952C0.143554 6.49389 1.04408 4.31707 2.68262 2.68192C4.31777 1.04337 6.4946 0.142853 8.81022 0.142854C11.1258 0.142854 13.3027 1.04337 14.9378 2.68192C16.5764 4.32046 17.4769 6.4939 17.4769 8.80952C17.4769 10.4751 17.0029 12.0934 16.1058 13.4882C15.2324 14.8457 14.0034 15.9324 12.5545 16.6298C12.1313 16.8296 11.6269 16.6535 11.4238 16.2304Z" fill="#2BC155"/>
                      \t\t\t\t\t\t\t\t\t\t\t\t\t\t<path d="M12.1045 9.2598C12.2704 9.42569 12.3516 9.64235 12.3516 9.85902C12.3516 10.0757 12.2704 10.2924 12.1045 10.4582L9.97506 12.5877C9.66361 12.8991 9.25059 13.0684 8.81387 13.0684C8.37715 13.0684 7.96074 12.8957 7.65267 12.5877L5.52324 10.4582C5.19147 10.1265 5.19147 9.59157 5.52324 9.2598C5.85501 8.92803 6.38991 8.92803 6.72168 9.2598L7.9709 10.509L7.9709 5.69834C7.9709 5.23116 8.35007 4.85199 8.81725 4.85199C9.28444 4.85199 9.66361 5.23116 9.66361 5.69834L9.66361 10.5124L10.9128 9.26319C11.2378 8.93142 11.7727 8.93142 12.1045 9.2598Z" fill="#2BC155"/>
                      \t\t\t\t\t\t\t\t\t\t\t\t\t\t</g>
                      \t\t\t\t\t\t\t\t\t\t\t\t\t\t<defs>
                      \t\t\t\t\t\t\t\t\t\t\t\t\t\t<clipPath id="clip2">
                      \t\t\t\t\t\t\t\t\t\t\t\t\t\t<rect width="17.3333" height="17.3333" fill="white" transform="matrix(-9.93477e-08 1 1 9.93477e-08 0.143555 0.142853)"/>
                      \t\t\t\t\t\t\t\t\t\t\t\t\t\t</clipPath>
                      \t\t\t\t\t\t\t\t\t\t\t\t\t\t</defs>
                      \t\t\t\t\t\t\t\t\t\t\t\t\t</svg>
                      \t\t\t\t\t\t\t\t\t\t\t\t</span>
                      \t\t\t\t\t\t\t\t\t\t\t\tIncome
                      \t\t\t\t\t\t\t\t\t\t\t</div>`

            } else if (user_id == sender_user_id) {
              html = `\t\t\t\t<div class="text-black">
                      \t\t\t\t\t\t\t\t\t\t\t\t<span class="mr-2 oi-icon bgl-danger">
                      \t\t\t\t\t\t\t\t\t\t\t\t\t<svg width="18" height="18" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      \t\t\t\t\t\t\t\t\t\t\t\t\t\t<path d="M6.57624 0.769646C6.77936 1.18944 6.59993 1.69725 6.18014 1.90038C5.01217 2.46236 4.02363 3.33579 3.31947 4.42928C2.59837 5.54986 2.21582 6.84986 2.21582 8.19048C2.21582 12.0363 5.34394 15.1644 9.18978 15.1644C13.0356 15.1644 16.1637 12.0363 16.1637 8.19048C16.1637 6.84986 15.7812 5.54985 15.0635 4.4259C14.3627 3.33241 13.3708 2.45897 12.2028 1.89699C11.783 1.69387 11.6036 1.18944 11.8067 0.766262C12.0098 0.34647 12.5143 0.167042 12.9374 0.370167C14.3898 1.06756 15.6187 2.1509 16.4887 3.51183C17.3825 4.90663 17.8564 6.52486 17.8564 8.19048C17.8564 10.5061 16.9559 12.6829 15.3174 14.3181C13.6822 15.9566 11.5054 16.8571 9.18978 16.8571C6.87415 16.8571 4.69733 15.9566 3.06217 14.3181C1.42363 12.6795 0.523111 10.5061 0.523111 8.19048C0.523111 6.52486 0.99707 4.90663 1.89421 3.51183C2.76764 2.15428 3.99655 1.06756 5.44551 0.370167C5.86868 0.170427 6.37311 0.34647 6.57624 0.769646Z" fill="#FF2E2E"/>
                      \t\t\t\t\t\t\t\t\t\t\t\t\t\t<path d="M5.89551 7.7402C5.72962 7.57431 5.64837 7.35765 5.64837 7.14098C5.64837 6.92431 5.72962 6.70765 5.89551 6.54176L8.02493 4.41233C8.33639 4.10088 8.74941 3.93161 9.18613 3.93161C9.62285 3.93161 10.0393 4.10426 10.3473 4.41233L12.4768 6.54176C12.8085 6.87353 12.8085 7.40843 12.4768 7.7402C12.145 8.07197 11.6101 8.07197 11.2783 7.7402L10.0291 6.49098L10.0291 11.3017C10.0291 11.7688 9.64993 12.148 9.18275 12.148C8.71556 12.148 8.33639 11.7688 8.33639 11.3017L8.33639 6.4876L7.08717 7.73681C6.76217 8.06858 6.22728 8.06858 5.89551 7.7402Z" fill="#FF2E2E"/>
                      \t\t\t\t\t\t\t\t\t\t\t\t\t\t</svg>

                      \t\t\t\t\t\t\t\t\t\t\t\t</span>
                      \t\t\t\t\t\t\t\t\t\t\t\tOutcome
                      \t\t\t\t\t\t\t\t\t\t\t</div>`

            } else {
              html = `${value}`
            }

            return html

          }
        },
        // {
        //   title: 'Actual Amount',
        //   valueKey: 'amount',
        //   html: true,
        //   alter: function (value, row) {
        //     var html = ''
        //     if (value)
        //       html = `<div  class="font-lg-4 font-weight-bolder text-dark">${parseFloat(value / 100).toFixed(3)}</div><div class="badge badge-light-success ml-1">${row.currency.code}</div>`
        //
        //
        //     return html
        //
        //
        //   }
        // },
        {
          title: 'Payable Amount',
          valueKey: 'amount',
          html: true,
          alter:  (value, row) => {
            var html = ''
            // if (value)
            //   html = ` <div  class=" font-weight-bolder text-dark">${parseFloat((value - row.vat - row.fee) / 100).toFixed(3)}</div><div class="badge badge-light-success ml-1">${row.currency.code}</div>`

            if (row.transaction_type_id == 6) {
              html = ` <div  class=" font-weight-bolder text-danger">- ${parseFloat((parseFloat(value)+parseFloat(row.vat)+parseFloat(row.fee))/100).toFixed(this.amountDecimalPlaces)}</div>`
              return html
            }
            if (row.total_amount != value){
              html = ` <div  class=" font-weight-bolder text-dark">${parseFloat((value)/100).toFixed(this.amountDecimalPlaces)}</div>`
            }
            else{
              html = ` <div  class=" font-weight-bolder text-dark">${parseFloat((value-row.vat-row.fee)/100).toFixed(this.amountDecimalPlaces)}</div>`
            }
            let currencyCode = `<div class="badge badge-light-success ">${row.currency.code}</div>`
            let showRemainingFunds = `<div class="badge badge-light-dark mt-1 ">Show Remaining Funds</div>`
            html = `
            <div class="row">
                    <div class="col-12 text-center ">
                        ${html}
                        ${currencyCode}
                        </br>
                        ${(row.transaction_type_id == 8 || row.transaction_type_id == 9)?showRemainingFunds:''}
                        ${(row.id == this.rowId && this.remainingFund == null)?`<div class="spinner-border text-primary spinner-border-sm"></div>`:''}
                        </br> <strong class="text-warning">${row.id == this.rowId && this.remainingFund != null? this.remainingFund/100:''}</strong>
                    </div>
                </div>
           
            `


            return html


          },
          cta: (row) => {
            if(row.transaction_type_id == 8 || row.transaction_type_id == 9){
              this.remainingFund = null
              this.rowId = row.id
              this.getRemainingFunds(row.uuid)
            }
            return
           
          }
        },
        // {
        //   title: 'Vat',
        //   valueKey: 'vat',
        //   html: true,
        //   alter: function (value, row) {
        //     var html = ''
        //
        //     html = ` <div  class="  text-dark">${parseFloat(value / 100).toFixed(5)}</div><div class="badge badge-light-success ml-1">${row.currency.code}</div>`
        //
        //
        //     return html
        //   }
        // },
        // {
        //   title: 'Fees',
        //   valueKey: 'fee',
        //   html: true,
        //   alter: function (value, row) {
        //     var html = ''
        //
        //     html = ` <div  class="  text-dark">${parseFloat(value / 100).toFixed(2)}</div><div class="badge badge-light-success ml-1">${row.currency.code}</div>`
        //
        //
        //     return html
        //
        //   }
        // },
        {
          title: 'Transaction Time/Date',
          titleHtml: `<br> <span class="text-warning font-weight-bolder">
														(Showing In GMT)
													</span>`,
          valueKey: 'created_at',
          alter: (value) => {
            //   return new Date(value).toISOString().slice(0, 16).replace('T', ' ')
            return new Date(value).toISOString().slice(0, 16).replace('T', ' ')
          }
        },
      ],
      actions: [
        {
          title: 'Details',
          cta: (row, index, btnIndex) => {
            this.$store.commit('setTransactionDetail', row)
            let propFilters = this.filteredData
            this.$router.push({name: 'transactions-details-with-id',query: { tab: this.tabToShow },params: {id:row.uuid,propFilters: JSON.stringify(propFilters)}})
            // this.$router.push({name: 'transactions-details'})
            // this.showAddEditTransactionRequestModal(row, index, btnIndex, 'all')
          },
          loading: false
        },
        {
          title: 'Refund',
          cta: (row) => {
            this.transactionId = row.uuid
            this.refundInitialAmount = parseFloat(row.total_amount/100).toFixed(this.amountDecimalPlaces
            )
            this.showRefundModal = true
          }
        },
        // {
        //   title: 'Charges',
        //   cta: (row, index, btnIndex) => {
        //     this.showAddEditTransactionRequestModal(row, index, btnIndex, 'charges')
        //   },
        //
        // },
        {
          title: 'Attempts History',
          cta: (row, index, btnIndex) => {
            this.$router.push({name: 'transactions-attempt', params: {uuid: row.uuid}})
          },

        },
      ],
      mutedData: [],
      selectedAccount: null,
      selectedType: null,
      filteredData: {status:1},
      filteredDataPending: {status:0},
      filteredDataFailed: {status:2},
      search: '',
      customerEmail: '',
      detailType: 'all',
      transactionChargesTable: [
        {
          header: [
            {
              title: 'Receiver Account Title'
            },
            {
              title: 'Reference ID'
            },
            {
              title: 'Actual Amount'
            },
            {
              title: 'Vat'
            },
            {
              title: 'Fees'
            },
          ],
          body: {
            getData: (row) => {
              // let finalData = []
              // console.log(row.receiver_account_title)
              // finalData.push(row.receiver_account_title)
              // finalData.push(row.payment_method.name)
              // finalData.push(parseFloat(row.amount / 100).toFixed(3))
              // finalData.push(parseFloat(row.vat / 100).toFixed(5))
              // finalData.push(parseFloat(row.fee / 100).toFixed(5))
              let finalData = []
              let temp = []
              temp.push(row.receiver_account_title)
              temp.push(row.reference_id)
              if (row.total_amount != row.amount){
                temp.push(row.total_amount / 100)
              }else{
                temp.push(row.amount / 100)
              }
              temp.push(row.vat / 100)
              temp.push(row.fee / 100)
              finalData.push(temp)
              // for (let [key, value] of Object.entries(row)) {
              //
              //
              //   let temp = []
              //   // temp.push(row.receiver_account_title)
              //   // temp.push(row.payment_method.name)
              //   // temp.push(row.amount / 100)
              //   // temp.push(row.vat / 100)
              //   // temp.push(row.fee / 100)
              //   // finalData.push(temp)
              // }
              return finalData
            }
          },
        },
        {
          heading:'Transaction Charges',
          header: [
            {
              title: 'UUID'
            },
            {
              title: 'Receiver Account Title'
            },
            {
              title: 'Sender Account Title'
            },
            {
              title: 'INCOME/OUTCOME'
            },
            {
              title: 'Amount'
            },
            {
              title: 'Total Amount'
            },
          ],
          body: {
            getData: (row) => {
              let user_id = this.$store.getters.getLoggedInUser?.id
              if(!user_id){
                return []
              }
              let finalData = []
              let temp = []
              for (let [key, value] of Object.entries(row.charges_transactions)) {
                let receiver_user_id = value.receiver_user_id
                let sender_user_id = value.sender_user_id
                let temp = []
                temp.push(value.uuid)
                temp.push(value.receiver_account_title)
                temp.push(value.sender_account_title)
                if (user_id == receiver_user_id) {
                  let html = `\t<div class="text-black">
                      \t\t\t\t\t\t\t\t\t\t\t\t<span class="mr-2 oi-icon bgl-success">
                      \t\t\t\t\t\t\t\t\t\t\t\t\t<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      \t\t\t\t\t\t\t\t\t\t\t\t\t\t<g clip-path="url(#clip2)">
                      \t\t\t\t\t\t\t\t\t\t\t\t\t\t<path d="M11.4238 16.2304C11.2206 15.8106 11.4001 15.3027 11.8199 15.0996C12.9878 14.5376 13.9764 13.6642 14.6805 12.5707C15.4016 11.4501 15.7842 10.1501 15.7842 8.80952C15.7842 4.96369 12.6561 1.83556 8.81022 1.83556C4.96439 1.83556 1.83626 4.96369 1.83626 8.80952C1.83626 10.1501 2.21881 11.4501 2.93652 12.5741C3.6373 13.6676 4.62923 14.541 5.7972 15.103C6.21699 15.3061 6.39642 15.8106 6.19329 16.2337C5.99017 16.6535 5.48574 16.833 5.06256 16.6298C3.61022 15.9324 2.38131 14.8491 1.51126 13.4882C0.617512 12.0934 0.143554 10.4751 0.143554 8.80952C0.143554 6.49389 1.04408 4.31707 2.68262 2.68192C4.31777 1.04337 6.4946 0.142853 8.81022 0.142854C11.1258 0.142854 13.3027 1.04337 14.9378 2.68192C16.5764 4.32046 17.4769 6.4939 17.4769 8.80952C17.4769 10.4751 17.0029 12.0934 16.1058 13.4882C15.2324 14.8457 14.0034 15.9324 12.5545 16.6298C12.1313 16.8296 11.6269 16.6535 11.4238 16.2304Z" fill="#2BC155"/>
                      \t\t\t\t\t\t\t\t\t\t\t\t\t\t<path d="M12.1045 9.2598C12.2704 9.42569 12.3516 9.64235 12.3516 9.85902C12.3516 10.0757 12.2704 10.2924 12.1045 10.4582L9.97506 12.5877C9.66361 12.8991 9.25059 13.0684 8.81387 13.0684C8.37715 13.0684 7.96074 12.8957 7.65267 12.5877L5.52324 10.4582C5.19147 10.1265 5.19147 9.59157 5.52324 9.2598C5.85501 8.92803 6.38991 8.92803 6.72168 9.2598L7.9709 10.509L7.9709 5.69834C7.9709 5.23116 8.35007 4.85199 8.81725 4.85199C9.28444 4.85199 9.66361 5.23116 9.66361 5.69834L9.66361 10.5124L10.9128 9.26319C11.2378 8.93142 11.7727 8.93142 12.1045 9.2598Z" fill="#2BC155"/>
                      \t\t\t\t\t\t\t\t\t\t\t\t\t\t</g>
                      \t\t\t\t\t\t\t\t\t\t\t\t\t\t<defs>
                      \t\t\t\t\t\t\t\t\t\t\t\t\t\t<clipPath id="clip2">
                      \t\t\t\t\t\t\t\t\t\t\t\t\t\t<rect width="17.3333" height="17.3333" fill="white" transform="matrix(-9.93477e-08 1 1 9.93477e-08 0.143555 0.142853)"/>
                      \t\t\t\t\t\t\t\t\t\t\t\t\t\t</clipPath>
                      \t\t\t\t\t\t\t\t\t\t\t\t\t\t</defs>
                      \t\t\t\t\t\t\t\t\t\t\t\t\t</svg>
                      \t\t\t\t\t\t\t\t\t\t\t\t</span>
                      \t\t\t\t\t\t\t\t\t\t\t\tIncome
                      \t\t\t\t\t\t\t\t\t\t\t</div>`
                  temp.push(html)
                } else if (user_id == sender_user_id) {
                  let html = `\t\t\t\t<div class="text-black">
                      \t\t\t\t\t\t\t\t\t\t\t\t<span class="mr-2 oi-icon bgl-danger">
                      \t\t\t\t\t\t\t\t\t\t\t\t\t<svg width="18" height="18" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      \t\t\t\t\t\t\t\t\t\t\t\t\t\t<path d="M6.57624 0.769646C6.77936 1.18944 6.59993 1.69725 6.18014 1.90038C5.01217 2.46236 4.02363 3.33579 3.31947 4.42928C2.59837 5.54986 2.21582 6.84986 2.21582 8.19048C2.21582 12.0363 5.34394 15.1644 9.18978 15.1644C13.0356 15.1644 16.1637 12.0363 16.1637 8.19048C16.1637 6.84986 15.7812 5.54985 15.0635 4.4259C14.3627 3.33241 13.3708 2.45897 12.2028 1.89699C11.783 1.69387 11.6036 1.18944 11.8067 0.766262C12.0098 0.34647 12.5143 0.167042 12.9374 0.370167C14.3898 1.06756 15.6187 2.1509 16.4887 3.51183C17.3825 4.90663 17.8564 6.52486 17.8564 8.19048C17.8564 10.5061 16.9559 12.6829 15.3174 14.3181C13.6822 15.9566 11.5054 16.8571 9.18978 16.8571C6.87415 16.8571 4.69733 15.9566 3.06217 14.3181C1.42363 12.6795 0.523111 10.5061 0.523111 8.19048C0.523111 6.52486 0.99707 4.90663 1.89421 3.51183C2.76764 2.15428 3.99655 1.06756 5.44551 0.370167C5.86868 0.170427 6.37311 0.34647 6.57624 0.769646Z" fill="#FF2E2E"/>
                      \t\t\t\t\t\t\t\t\t\t\t\t\t\t<path d="M5.89551 7.7402C5.72962 7.57431 5.64837 7.35765 5.64837 7.14098C5.64837 6.92431 5.72962 6.70765 5.89551 6.54176L8.02493 4.41233C8.33639 4.10088 8.74941 3.93161 9.18613 3.93161C9.62285 3.93161 10.0393 4.10426 10.3473 4.41233L12.4768 6.54176C12.8085 6.87353 12.8085 7.40843 12.4768 7.7402C12.145 8.07197 11.6101 8.07197 11.2783 7.7402L10.0291 6.49098L10.0291 11.3017C10.0291 11.7688 9.64993 12.148 9.18275 12.148C8.71556 12.148 8.33639 11.7688 8.33639 11.3017L8.33639 6.4876L7.08717 7.73681C6.76217 8.06858 6.22728 8.06858 5.89551 7.7402Z" fill="#FF2E2E"/>
                      \t\t\t\t\t\t\t\t\t\t\t\t\t\t</svg>

                      \t\t\t\t\t\t\t\t\t\t\t\t</span>
                      \t\t\t\t\t\t\t\t\t\t\t\tOutcome
                      \t\t\t\t\t\t\t\t\t\t\t</div>`
                  temp.push(html)
                }
                temp.push(value.amount / 100)
                temp.push(value.total_amount / 100)
                finalData.push(temp)
              }
              return finalData
            }
          },
        }
      ],
      refundInitialAmount:'',
      selectedMerchant: null,
      selectedStore: null,
      selectedTerminal: null,
      selectedChannel: null,
      storeData: [],
      terminalData: [],
      channelData: [],
      terminalLoader:false,
      channelLoader:false,
    }
  },
  methods: {
    validateEmail() {
      let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
      
      if (!(reg).test(this.customerEmail) && this.customerEmail != '') {
        this.validationMsg['email'] = 'Please enter a valid email address';
      } else {
        this.validationMsg['email'] = '';
      }
    },
    getRemainingFunds(transactionId) {
      let data = {
        transactionId: transactionId,
        refundAmountDetails:1,
        transactionDetail: 1
      }
      this.makeRequest("post", "v1/get-transactions", data, {}, false).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                if(responseData){
                  this.remainingFund = responseData.remainingRefundAmount
                }

              }
            }
          }
      );
    },
    showAddEditTransactionRequestModal(data, index, btnIndex, actionType) {
      this.$refs.commonTableRef.tableButtons[index][btnIndex].loading = true
      let detailsData = {
        transactionDetail: 1,
        transactionId: data.uuid,
      }
      this.makeRequest('post', 'v1/get-transactions', detailsData).then(callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            if (callResponse.response.data.data) {
              let data = callResponse.response.data.data
              if (actionType == 'charges') {
                this.transactionRequestSelectedData = data.transaction_charges
                this.detailType = actionType
              } else {
                this.transactionRequestSelectedData = data
                this.detailType = 'all'
              }
              this.showTransactionRequestModal = true
            }
          } else if (code == 401) {
            this.$router.push({name: 'send-otp'});
          }
        }
        this.$refs.commonTableRef.tableButtons[index][btnIndex].loading = false
      })
      this.transactionRequestSelectedIndex = index
    },
    formatDate(val){
      let date = new Date(val)
      let day = ("0" + date.getDate()).slice(-2)
      let month = ("0" + (date.getMonth() + 1)).slice(-2)
      let year= date.getFullYear()

      let formatted_date = year+'-'+month+'-'+day
      return formatted_date
    },
    onSubmitFilters() {
      if(this.validationMsg['email'] != ''){
        return
      }
      let dataFiltered = {}

      if(this.selectedStore){
        dataFiltered.selectedStore = this.selectedStore
        dataFiltered.storeId = this.selectedStore
      }
      if(this.selectedTerminal){
        dataFiltered.selectedTerminal = this.selectedTerminal
        dataFiltered.terminalId = this.selectedTerminal.id
      }
      if(this.selectedChannel){
        dataFiltered.selectedChannel = this.selectedChannel
        dataFiltered.channelId = this.selectedChannel.id
      }

      if(this.toDate){
        dataFiltered.toDate = this.formatDate(this.toDate)
      }
      if(this.fromDate){
        dataFiltered.fromDate = this.formatDate(this.fromDate)
      }

      dataFiltered.selectedType = this.selectedType
      dataFiltered.selectedAccount = this.selectedAccount

      if (this.search != '' && this.selectedType && this.selectedAccount) {
        dataFiltered.transactionId = this.search
        dataFiltered.transactionTypeId = this.selectedType.id
        dataFiltered.userAccountId = this.selectedAccount.id

      } else if (this.search != '' && this.selectedType && !this.selectedAccount) {

        dataFiltered.transactionId = this.search
        dataFiltered.transactionTypeId = this.selectedType.id

      } else if (this.search != '' && !this.selectedType && this.selectedAccount) {

        dataFiltered.transactionId = this.search
        dataFiltered.userAccountId = this.selectedAccount.id

      } else if (this.search != '' && !this.selectedType && !this.selectedAccount) {

        dataFiltered.transactionId = this.search

      } else if (this.search == '' && this.selectedType && this.selectedAccount) {

        dataFiltered.transactionTypeId = this.selectedType.id
        dataFiltered.userAccountId = this.selectedAccount.id

      } else if (this.search == '' && this.selectedType && !this.selectedAccount) {

        dataFiltered.transactionTypeId = this.selectedType.id

      } else if (this.search == '' && !this.selectedType && this.selectedAccount) {

        dataFiltered.userAccountId = this.selectedAccount.id

      }

      if(this.customerEmail != ''){
        dataFiltered.customerEmail = this.customerEmail
      }


      if (this.tabToShow == 1) {
        dataFiltered.tabToShow = 1
        dataFiltered.status = 1
        this.filteredData = dataFiltered

      } else if (this.tabToShow == 2) {
        dataFiltered.tabToShow = 2
        dataFiltered.status = 0
        this.filteredDataPending = dataFiltered
      } else {
        dataFiltered.tabToShow = 3
        dataFiltered.status = 2
        this.filteredDataFailed = dataFiltered
      }


    },
    onClearFilters() {
      this.toDate = null
      this.fromDate = null
      this.selectedType = null
      this.selectedAccount = null
      this.search = ''
      this.customerEmail = ''
      this.selectedStore = null
      this.selectedTerminal = null
      this.selectedChannel = null
      this.filteredData = {status:1}
      this.filteredDataPending = {status:0}
      this.filteredDataFailed = {status:2}

    },
    selectedFullObj(obj){
      if(obj){
        this.terminalData = obj.terminals
      }else{
        this.terminalData = []
      }
    },
  },
  watch: {
    tabToShow(val) {
      // this.onClearFilters()
      // send call for second and third tabs if tab is clicked, send call if not sent before
      if (val == 2 && !this.tab2sendCall)
        this.tab2sendCall = true;
      else if (val == 3 && !this.tab3sendCall)
        this.tab3sendCall = true;
    },
    selectedStore(val) {
      this.selectedTerminal = null
      if(!val){
        this.terminalData = []
      }
    },
    selectedTerminal(val) {
      this.selectedChannel = null
      this.channelData = []
      if(val){
        this.channelData = val.channels
      }
    },
  }
}
</script>
<style>
.table-scroll-y {
  display: block;
  overflow-x: auto;
  white-space: nowrap;
}

.minimum-h {
  min-height: 300px !important;
}
</style>

